import { render, staticRenderFns } from "./CardContacts.vue?vue&type=template&id=3f2ab392&scoped=true"
import script from "./CardContacts.vue?vue&type=script&lang=js"
export * from "./CardContacts.vue?vue&type=script&lang=js"
import style0 from "./CardContacts.vue?vue&type=style&index=0&id=3f2ab392&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2ab392",
  null
  
)

export default component.exports